
window.addEventListener("scroll", function () {
    const scrollTop = window.scrollY;
    const docHeight = document.body.scrollHeight - window.innerHeight;
    const scrollPercent = (scrollTop / docHeight) * 100;

    const stickyEl = document.querySelector(".cstm-sticky-add-to-cart");

    if (!stickyEl) return;

    if (scrollPercent >= 25 && scrollPercent < 80) {
        stickyEl.classList.add("show");
        stickyEl.classList.remove("hide");
    } else if (scrollPercent >= 80) {
        stickyEl.classList.add("hide");
        stickyEl.classList.remove("show");
    } else {
        
        stickyEl.classList.remove("show", "hide");
    }
});
